import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Star } from 'lucide-react';

export const BilanSatisfaction = ({ data, onSaisirEntreprise }) => {
  const Block = ({ cible, label }) => {
    const s = data.satisfaction[cible];
    return (
      <Card className="border-0 shadow-sm" data-testid={`bilan-satisfaction-${cible}`}>
        <CardHeader className="pb-2 flex-row items-center justify-between"><CardTitle className="text-base flex items-center gap-2"><Star className="w-4 h-4 text-amber-500" /> {label} <span className="text-xs font-normal text-slate-400">({s.nb_reponses} réponse(s))</span></CardTitle>
          {cible === 'entreprise' && <Button size="sm" variant="outline" className="text-xs" onClick={onSaisirEntreprise} data-testid="bilan-sat-entreprise-btn">Saisir (entreprise)</Button>}</CardHeader>
        <CardContent className="space-y-1.5 text-sm">
          {s.questions.map(q => (
            <div key={q.id} className="flex items-start justify-between gap-3"><span className="text-slate-700">{q.libelle}</span>
              <span className="font-semibold shrink-0">{q.type === 'note' ? (q.moyenne != null ? `${q.moyenne} / 5` : '—') : q.type === 'ouinon' ? (q.taux_oui != null ? `${q.taux_oui} % oui` : '—') : <span className="text-xs font-normal text-slate-500 max-w-xs text-right block">{(q.reponses || []).join(' · ') || '—'}</span>}</span>
            </div>
          ))}
        </CardContent>
      </Card>
    );
  };
  return <div className="grid grid-cols-1 lg:grid-cols-2 gap-4"><Block cible="candidat" label="Satisfaction des candidats" /><Block cible="entreprise" label="Satisfaction de l'entreprise" /></div>;
};
